'use client';

import { useFriendlyViewPort } from '../../../hooks/useFriendlyViewPort';
import { useViewportSizeTracking } from '../../../hooks/useViewportSizeTracking';
import PageElement from '../../../components/PageElements/PageElement';
import jobbVal from './page.val';
import { useVal, useValRoute } from '../../../val/val.client';
import PageIngress from '../../../components/PageIngress/PageIngress';
import LargeLayout from '../../../containers/LargeLayout';
import PageHeader from '../../../components/PageHeader/PageHeader';
import ContactFooter from '../../../components/ContactFooter/ContactFooter';
import allEmployeesVal from '../../../data/employees.val';
import Button from '../../../components/Button/Button';
import { notFound } from 'next/navigation';

const Work = ({ params }: { params: Promise<never> }) => {
  const page = useValRoute(jobbVal, params);
  const employees = useVal(allEmployeesVal);

  useFriendlyViewPort();
  useViewportSizeTracking();

  if (!page) {
    return notFound();
  }
  const {
    header,
    subheader,
    ingress,
    pageElements,
    pageImage,
    availablePositions,
    contact,
  } = page;

  const contactPeople = contact.persons
    .map((person) => employees[person])
    .filter(Boolean);

  const links = availablePositions
    .filter((pos) => pos.active)
    .map((pos) => ({
      text: pos.title,
      href: pos.positionSlug,
    }));

  return (
    <>
      <div id="jobb" className="bg-blank-black text-blank-yellow">
        <LargeLayout>
          <PageHeader header={header} subheader={subheader} image={pageImage} />

          <PageIngress
            text={ingress}
            rightContent={
              <div className="flex flex-col gap-16 items-start tablet:items-end">
                {links.map((link, index) => (
                  <Button
                    key={index}
                    withArrow
                    scheme="dark"
                    href={link.href}
                    variant="secondary"
                  >
                    {link.text}
                  </Button>
                ))}
              </div>
            }
          />

          {pageElements.map((element, i) => {
            return <PageElement key={i} element={element} />;
          })}

          <ContactFooter
            title={contact.title}
            link={contact.link}
            contactPeople={contactPeople}
          />
        </LargeLayout>
      </div>
    </>
  );
};

export default Work;
